




































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_clasificaciones from '@/mixins/axios/indicador_clasificaciones'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
                      
          
            {
                tag:'clasificacion',
                data:'clasificacion',
                active:true
            },
           {
                tag:'indicadores_clasificacion',
                data:'indicadores_clasificacion',
                active:true
            },
               {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            
           
        ],




        id:null as any,

      clasificacion:'' as any,
     indicadores_clasificacion:'' as any,
     
         
         
              indicador_clasifdata:[] as any,
      
    }
  },
     mixins: [indicador_clasificaciones],
     validations: {
    
           clasificacion: {
      required,
    },
   indicadores_clasificacion: {
      required,
    },
     

   
  },
  methods:{
       
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_CLASIFICACION(row).then(response => {

                    if (response != null) {

 this.indicador_clasifdata=this.indicador_clasifdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
     
           
                 this.clasificacion=null;
 this.indicadores_clasificacion=null;
        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_clasif').modal('show')
      },
seteditar(row){

 this.id=row.id;
 this.clasificacion=row.clasificacion;
this.indicadores_clasificacion=row.indicadores_clasificacion;
            
          
 $('#ac_modal_indicador_clasif').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_CLASIFICACION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_clasifdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Clasificaciones, refresque la pagina");

                    }
                        $("#ac_modal_indicador_clasif").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_CLASIFICACION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear pmd, refresque la pagina");
  this.indicador_clasifdata=this.indicador_clasifdata.filter(item => item.id !== dat.id);
 this.indicador_clasifdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Indicador Clasificaciones, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
 
           clasificacion:this.clasificacion, 
           indicadores_clasificacion:this.indicadores_clasificacion,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_CLASIFICACION(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_clasifdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

